/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassroomDisciplineBotExamVisualizationViewModel } from "../types/ClassroomDisciplineBotExamVisualizationViewModel.ts";
import { botExamVisualizationQuestionViewModelSchema } from "./botExamVisualizationQuestionViewModelSchema.ts";

export const classroomDisciplineBotExamVisualizationViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da prova gerada por bot.")),
  title: z
    .string()
    .describe("Título da prova em português (pt-BR). Opcional.")
    .nullish(),
  instruction: z
    .string()
    .describe(
      "Instrução geral da prova decodificada (HTML entities convertidas). Opcional.",
    )
    .nullish(),
  currentPage: z.optional(
    z.number().int().describe("Número da página atual retornada."),
  ),
  totalPages: z.optional(
    z
      .number()
      .int()
      .describe(
        "Total de páginas disponíveis para o tamanho de página solicitado.",
      ),
  ),
  totalCount: z.optional(
    z
      .number()
      .int()
      .describe("Total de questões em pt-BR cadastradas para a prova."),
  ),
  pageSize: z.optional(
    z
      .number()
      .int()
      .describe("Quantidade de questões por página utilizada na consulta."),
  ),
  questions: z
    .array(z.lazy(() => botExamVisualizationQuestionViewModelSchema))
    .describe(
      "Questões da página atual em pt-BR, cada uma com suas traduções para os demais idiomas cadastrados.",
    )
    .nullish(),
}) as unknown as ToZod<ClassroomDisciplineBotExamVisualizationViewModel>;
